import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  filter: {
    '=': [
      {
        '@.': '!id',
      },
      {
        '@$': 'subawardId',
      },
    ],
  },
  target: 'ent:!subawards:!subaward',
  quantity: 1,
  selection: {
    '@': 'main',
  },
  subqueries: {
    main: {
      selection: {
        '{}': {
          type: 'metric',
          overflowActions: {
            '[]': [
              {
                '{}': {
                  icon: 'atn-icon atn-link',
                  action: {
                    '{}': {
                      payload: {
                        '{}': {
                          goto: {
                            '{}': {
                              variables: {
                                '{}': {
                                  subrecipientId: {
                                    '@.': '!id',
                                  },
                                },
                              },
                              navigationId: 'subrecipient-details',
                              fragment: 'institutional-risk-assessments',
                            },
                          },
                        },
                      },
                      operation: 'ui.navigate',
                    },
                  },
                },
              },
            ],
          },
          content: {
            '@': 'subrecipientSnapshot',
          },
        },
      },
      ref: {
        attr: 'attr:ent#!subawards#!subaward:!subrecip',
      },
      target: 'ent:!subrecips:!subrecip',
      subqueries: {
        subrecipientSnapshot: {
          selection: {
            '{}': {
              name: 'Subrecipient Risk Score',
              event: {
                '{}': {
                  time: {
                    '++': [
                      '(',
                      {
                        '@.': '!when',
                      },
                      ')',
                    ],
                  },
                },
              },
              value: {
                '{}': {
                  aside: {
                    '++': [
                      '/ ',
                      {
                        score: {
                          possible: '*',
                        },
                      },
                    ],
                  },
                  emphasis: {
                    score: '*',
                  },
                },
              },
            },
          },
          ref: {
            attr: 'attr:snap#!subrecips#!subrecipient_risk_survey:!subj',
          },
          target: 'snap:!subrecips:!subrecipient_risk_survey',
          quantity: 1,
        },
      },
    },
  },
}
